export const shouldShowInternalAssistForPath = (path: string | null | undefined): boolean => {
  const normalizedPath = (path ?? "").trim().replace(/\/+$/, "") || "/"

  return normalizedPath !== "/presentation" && !normalizedPath.startsWith("/presentation/")
}
